<template>
    <div>
        <Card>
            <Row :gutter="24">
                <Col span="3">
                    <Input v-model="params.workflow_type" @on-change="assetWorkflowAll">
                        <span slot="prepend">类型</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.name" @on-change="assetWorkflowAll">
                        <span slot="prepend">申请人</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.department" @on-change="assetWorkflowAll">
                        <span slot="prepend">部门</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.created_at" @on-change="assetWorkflowAll">
                        <span slot="prepend">时间</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.approval" @on-change="assetWorkflowAll">
                        <span slot="prepend">审批状态</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Input v-model="params.sn_list" @on-change="assetWorkflowAll">
                        <span slot="prepend">资产编码</span>
                    </Input>
                </Col>
                <Col span="3">
                    <Button type="text" icon="md-refresh-circle" @click="assetWorkflowAll"></Button>
                </Col>
            </Row>

        </Card>
        <Table highlight-row ref="currentRowTable" :columns="columns3" :data="assetList"></Table>
        <Page :total="count" :current="params.page" show-sizer show-total :page-size="params.size" @on-change="currentHandle" @on-page-size-change="pageSizeHandle"></Page>
    </div>
</template>
<script>
import { getAssetWorkflowAll } from '@/api/cmdb'
export default {
  data () {
    return {
      columns3: [
        {
          width: 60,
          align: 'center',
          key: 'id',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '类型',
          key: 'workflow_type',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', [
              h('Tag', {
                props: {
                  color: params.row.workflow_type === '领用' ? '#7232dd' : params.row.workflow_type === '转让' ? 'red' : 'red'
                }
              }, params.row.workflow_type)
            ])
          }
        },
        {
          title: '时间',
          key: 'created_at'
        },
        {
          title: '申请人',
          key: 'name',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '申请人邮箱',
          key: 'mail',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '转让人',
          key: 'transfer_name',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.transfer_name),
              h('Tag', {
                props: {
                  type: 'border',
                  color: params.row.transfer_status === '审批中' ? 'yellow' : params.row.transfer_status === '同意' ? 'green' : 'red'
                },
                style: {
                  marginLeft: '5px',
                  display: params.row.transfer_status ? 'inline-block' : 'none'
                }
              }, params.row.transfer_status)
            ])
          }
        },
        {
          title: '转让人邮箱',
          key: 'transfer_mail',
          align: 'center',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '更换原因',
          key: 'replace_reason',
          align: 'center',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '总资产',
          key: 'sn_list_by_total',
          align: 'center',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '固资信息',
          key: 'sn_list_info',
          ellipsis: true,
          tooltip: true,
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', { }, [
              params.row.sn_list_info.map((item, _) => {
                return h('div', [
                  h('Tag', {
                    props: {
                      type: 'border',
                      color: '#7232dd'
                    },
                    style: {
                      marginLeft: '5px',
                      display: item.asset_id ? 'inline-block' : 'none'
                    }
                  }, item.asset_id),

                  h('Tag', {
                    props: {
                      type: 'border',
                      color: 'blue'
                    },
                    style: {
                      marginLeft: '5px',
                      display: item.name ? 'inline-block' : 'none'
                    }
                  }, item.name)
                ])
              })
            ]
            )
          }
        },
        {
          title: '',
          minWidth: 10,
          ellipsis: true,
          render: (h, params) => {
            return h('icon', { props: { type: 'ios-arrow-forward' } })
          }
        },
        {
          title: '固资信息',
          key: 'sn_list_info',
          ellipsis: true,
          tooltip: true,
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', { }, [
              params.row.new_sn_list_info.map((item, _) => {
                return h('div', [
                  h('Tag', {
                    props: {
                      type: 'border',
                      color: '#7232dd'
                    },
                    style: {
                      marginLeft: '5px',
                      display: item.asset_id ? 'inline-block' : 'none'
                    }
                  }, item.asset_id),

                  h('Tag', {
                    props: {
                      type: 'border',
                      color: 'blue'
                    },
                    style: {
                      marginLeft: '5px',
                      display: item.name ? 'inline-block' : 'none'
                    }
                  }, item.name)
                ])
              })
            ]
            )
          }
        },
        {
          title: '操作人',
          key: 'operator_info',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.operator_info.name),
              h('Tag', {
                props: {
                  type: 'border',
                  color: params.row.approval === '审批中' ? 'yellow' : params.row.approval === '同意' ? 'green' : 'red'
                },
                style: {
                  marginLeft: '5px',
                  display: params.row.operator_info ? 'inline-block' : 'none'
                }
              }, params.row.approval)
            ])
          }
        }
      ],
      params: { page: 1, size: 10 },
      assetList: [],
      count: 0
    }
  },
  mounted () {
    this.assetWorkflowAll()
  },
  methods: {
    assetWorkflowAll () {
      getAssetWorkflowAll(this.params).then(rsp => {
        const { results, count } = rsp.data
        this.assetList = results
        this.count = count
      })
    },
    currentHandle (page) {
      this.params.page = page
      this.assetWorkflowAll()
    },
    pageSizeHandle (size) {
      this.params.size = size
      this.assetWorkflowAll()
    }
  }
}
</script>
